// ********************************************************
// **** Customer analysis Section Routes/Paths ****
// ********************************************************

// ** Customer Segment **
export const URL_CUSTOMER_ANALYSIS_TABLE = '/customer_analysis';
